<div class="d-flex flex-column gap-5">
  <div class="d-flex align-items-center">
    <base-avatar
      [image]="review?.ratedBy?.avatar || ''"
      [size]="avatarSize.medium"
      [avatarClasses]="['cursor-auto', 'me-2']"
    ></base-avatar>
    <div class="d-flex flex-column me-3">
      <span class="fw-bold">{{ review?.ratedBy?.firstName }} {{ review?.ratedBy?.lastName }}</span>
      <span *ngIf="review?.ratedBy?.isAdmin; else locationsInfo">{{ 'placeholders.administrator' | translate }}</span>
      <span
        *ngIf="review"
        class="text-dark-gray"
        >{{ review.updatedAt | baseFormatDate }} | {{ 'dateTime.timePrefix' | translate }}
        {{ review.updatedAt | baseFormatTime }}</span
      >
    </div>
    <base-rating
      [currentRate]="review?.rating"
      [hideCount]="true"
    ></base-rating>
  </div>
  <p class="mb-0">
    {{ review?.note }}
  </p>
</div>

<ng-template #locationsInfo>
  <ng-container *ngIf="review?.ratedBy?.locations as locations">
    <span *ngIf="locations.length > 0">
      {{ locations[0] }}
      <span
        *ngIf="locations.length > 1"
        [ngbTooltip]="locationsListTooltip"
      >
        + {{ locations.length - 1 }} {{ 'additional' | translate }}</span
      >
    </span>
  </ng-container>
</ng-template>

<ng-template #locationsListTooltip>
  <ul class="list-unstyled text-start m-2">
    <li *ngFor="let location of review?.ratedBy?.locations || []; let last = last">
      {{ location }}<span *ngIf="!last">, </span>
    </li>
  </ul>
</ng-template>
